'use strict';

goog.provide("Ntry.EntityManager");

goog.require("Ntry.Entity");
goog.require("Ntry.Utils");

Ntry.EntityManager = (function (){
    return function() {
        this._entities = {};

        this._registeredComponents = {}

        this._componentsMap = {};
        this._entityCount = 0;
    }
})();


(function(p){
    p.registerComponent = function(componentPrototype) {
        var componentType = new componentPrototype({}).type;
        this._registeredComponents[componentType] =
            componentPrototype;
        this._componentsMap[componentType] = {};
    };

    p.unregisterComponents = function() {
    };

    p.addEntity = function() {
        var entity = new Ntry.Entity(this._entityCount++);
        this._entities[entity.id] = entity;
        return entity;
    };

    p.hasEntity = function(entityId) {
        return entityId in this._entities;
    };

    p.getEntity = function(entityId) {
        return this._entities[entityId]
    };

    p.getEntities = function() {
        return this._entities;
    };

    p.removeEntity = function(entityId) {
        for (var type in this._componentsMap) {
            delete this._componentsMap[type][entityId];
        }
        delete this._entities[entityId];
    };

    p.addComponent = function(entityId, component) {
        var entity = this.getEntity(entityId);
        component = new this._registeredComponents[component.type](component);
        entity.components[component.type] = component;
        this._componentsMap[component.type][entityId] = entity;
        return component;
    };

    p.hasComponent = function(entityId, componentType) {
        var entity = this.getEntity(entityId);
        if (entity === undefined)
            return false;
        else
            return entity.components[componentType] !== undefined;
    };

    p.getComponent = function(entityId, componentType) {
        var entity = this.getEntity(entityId);
        if (entity === undefined)
            return false;
        else
            return entity.components[componentType];
    };

    p.removeComponent = function(entityId, componentType) {
        var entity = this.getEntity(entityId);
        if (entity === undefined)
            return null;
        else {
            delete entity.components[componentType];
            delete this._componentsMap[componentType][entityId];
            return entity;
        }
    };

    p.removeComponents = function(entityId) {
        var entity = this.getEntity(entityId);
        if (entity === undefined)
            return null;
        else {
            for (var key in entity.components) {
                this.removeComponent(entityId, key);
            }
            return entity;
        }
    };

    p.getEntitiesByComponent = function(componentType) {
        return this._componentsMap[componentType];
    };

    /**
     * find entity by components.
     * argument length is free.
     */
    p.find = function(component) {
        var entities = this.getEntitiesByComponent(component.type);
        var args = Array.prototype.slice.call(arguments);
        args.unshift(_.values(entities));
        var fitEntities = this._findByOne.apply(this, args);
        return fitEntities;
    }

    p._findByOne = function(entities, component) {
        var fitEntities = [];
        var args = Array.prototype.slice.call(arguments);
        args = args.splice(2);
        args.unshift(fitEntities);
        for (var i in entities) {
            var entity = entities[i];
            var comp = this.getComponent(entity.id, component.type);
            if (!comp)
                continue;
            if (Ntry.compareObjects(comp, component))
                fitEntities.push(entity);
        }
        if (fitEntities.length == 0)
            return [];
        else if (args.length > 1)
            return this._findByOne.apply(this, args);
        else
            return fitEntities;
    }

    p.getComponents = function(entityId) {
        return this.getEntity(entityId).components;
    }

    p.getComponentsJSON = function(entityId) {
        var entity = this.getEntity(entityId);
        var components = entity.components;
        var ret = {};
        ret.origins = [];

        var obj = {};

        for (var i in components) {
            ret.origins.push(i);
            if (Ntry.STATIC.RESTORE_BLACK_LIST.indexOf(Number(i)) > -1) {
                continue;
            }
            obj[i] = components[i];
        };
        ret.data = JSON.parse(JSON.stringify(obj));

        return ret;
    };

    p.fromJSON = function(entitiesJSON) {
        if (!(entitiesJSON instanceof Array))
            return;
        for (var i in entitiesJSON) {
            var entityModel = entitiesJSON[i];
            var entity = this.addEntity();
            if (typeof entityModel.components === "object") {
                for (var key in entityModel.components) {
                    var componentModel = entityModel.components[key];
                    componentModel.type = key;
                    this.addComponent(entity.id, componentModel);
                }
            }
        }
    };

    p.toJSON = function() {
    };

    p.clear = function() {
        this._entities = {};

        for (var type in this._componentsMap) {
            this._componentsMap[type] = {};
        }
    };

})(Ntry.EntityManager.prototype);

